<template>
  <div id='app'>
    <BModalOrchestrator />
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <!-- UpdateMessageModal is rendered here and registered with the store -->
    <UpdateMessageModal ref="updateMessageModal" />
  </div>
</template>

<script setup>
// Main app component. Registers the UpdateMessageModal instance with the Pinia store on mount.
import { ref, onMounted } from 'vue'
import UpdateMessageModal from '@/components/UIComponents/UpdateMessageModal.vue'
import { useUpdateMessageStore } from '@/store/ui/updateMessageStore'

// Ref to the modal instance
const updateMessageModal = ref(null)
// Access the Pinia store
const updateMessageStore = useUpdateMessageStore()

// Register the modal instance with the store after mount
onMounted(() => {
  updateMessageStore.register(updateMessageModal.value)
})
</script>
